import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from '@mui/material';

const NeedsTrackingModal = ({
  open,
  onClose,
  onConfirm,
  confirmMessage,
  disableConfirm = false // optional prop
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Notice</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1">{confirmMessage}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} 
        sx={{
          backgroundColor: '#ec008c',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d5006d',
          },
        }}>Cancel</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          //color="primary"
          sx={{
          backgroundColor: '#ec008c',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d5006d',
          },
        }}
          disabled={disableConfirm}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NeedsTrackingModal;
